import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

import { selectUser } from 'selectors/user';
import { useSnackbar } from 'notistack';
import {
  ACTION_RENEW,
  confirmCheckoutSuccess,
  confirmRenewalCheckoutSuccess,
  getLastLocationAndState,
} from 'util/APIUtils';
import LoadingIndicator from 'components/LoadingIndicator';

const CheckoutComplete = () => {
  const user = useSelector(selectUser);
  const enqueueSnackbar = useSnackbar();
  const lastLocationAndState = getLastLocationAndState();
  const [nextLocationAndState, setNextLocationAndState] = useState(lastLocationAndState);
  const [loading, setLoading] = useState(true);

  const confirmSuccess = useCallback(() => {
    if (lastLocationAndState) {
      const { state } = lastLocationAndState;
      if (state && state.action === ACTION_RENEW) {
        confirmRenewalCheckoutSuccess(state.renewalId, state.token)
          .then(() => {
            setLoading(false);
          })
          .catch(error => {
            setLoading(false);
            enqueueSnackbar((error && error.message) || 'Oops! Something went wrong. Please try again!', { variant: 'error' });
          });

      } else if (state && state.order && user) {
        confirmCheckoutSuccess(user.id, state.order.id)
          .then(updatedOrder => {
            setNextLocationAndState(Object.assign(
              {},
              lastLocationAndState,
              { state: { order: updatedOrder } }));
            setLoading(false);
          })
          .catch(error => {
            enqueueSnackbar((error && error.message) || 'Oops! Something went wrong. Please try again!', { variant: 'error' });
            setLoading(false);
          });

      }
    }
  }, [lastLocationAndState, enqueueSnackbar, user]);

  useEffect(() => {
    confirmSuccess();
  }, [confirmSuccess]);

  return loading ? <LoadingIndicator />
    : <Redirect to={nextLocationAndState} />
};

export default CheckoutComplete;
